import React, { Component } from 'react';
import './Calendar.css'
import moment from 'moment'
// eslint-disable-next-line
import moment_it from 'moment/locale/sl'
import { withRouter } from 'react-router-dom'

class Calendar extends Component {

    
    constructor(props){
	super(props)
	this.state = {
	    currentPeriod: moment()
	}
    }
    
    render() {

	var {currentPeriod} = this.state; 
	const {eventsDates} = this.props

	currentPeriod = moment(currentPeriod).startOf('month')
	var period = moment(currentPeriod.format('YYYY/MM/DD'), 'YYYY/MM/DD').subtract( moment(currentPeriod.format('YYYY/MM/DD'), 'YYYY/MM/DD').startOf('month').day(), 'd')
	
	const changeMonth = (months) => {
	    var {currentPeriod} = this.state;
	    currentPeriod.add(months, 'months')
	    this.setState({currentPeriod})
	}

	const hasEvents = (period) => {
	    if(eventsDates)
		return eventsDates.indexOf(period)>=0
	    
	}

	const showEvents = (period) => {
	    if(hasEvents(period)){
		this.props.history.push('/events?period='+period)
		window.scrollTo(0, 0);
	    }
	}
	
	return (
	    <div className="Calendar">
		<div className="info">
		    <div className="title">KOLEDAR DOGODKOV</div>
		    <div className="description">Klikni na datum in odkrij, kaj vam bo Radijski oder v tem mesecu ponudil po radijskih valovih, na naših odrih in tudi drugje.</div>
		</div>
		
		<div className="calendarContainer">
		    <table className="calendar">
			<thead>
			    <tr>
				<td>
				    <i className="fa fa-angle-left" onClick={() => changeMonth(-1)}></i>
				</td>
				<td  colSpan="5">
				    {currentPeriod.format("MMMM YYYY")}
				</td>
				<td>
				    <i className="fa fa-angle-right" onClick={() => changeMonth(1)}></i>
				</td>
			    </tr>
			    <tr>
				{moment.weekdaysShort(true).map((x, i) => {  return (<td key={i}>{x.replace('.', '')}</td>) })}
			    </tr>
			    
			</thead>
			<tbody>
			    {Array(5).fill().map((_, i) => {return (<tr key={i}>
				
				{moment.weekdaysShort(true).map((x, i) => {
				     period.add(1, 'd')
				     const p = period.format('YYYY/MM/DD')
				     return (<td key={i} className={[((period.month()!== currentPeriod.month()) ? 'isAnotherMonth': ''), (p===moment().format('YYYY/MM/DD') ? 'isToday' : ''), (moment(p, 'YYYY/MM/DD').isBefore(moment().startOf('day')) ? 'isBefore' : ''), hasEvents(p) ? 'hasEvents' : ''].join(" ")} onClick={() => {
					     if(moment(p, 'YYYY/MM/DD').isSameOrAfter(moment().startOf('day')))
						 showEvents(p)
				     }}><div>{period.date()}</div></td>)

				})}
			    </tr>) })}
			    
			</tbody>
		    </table>
		</div>
	    </div>
	);
    }
}

export default withRouter(Calendar);



// WEBPACK FOOTER //
// ./src/components/Calendar/index.jsx